import { render, staticRenderFns } from "./AdicionarAutorizado.vue?vue&type=template&id=2a40e4ee&"
import script from "./AdicionarAutorizado.vue?vue&type=script&lang=js&"
export * from "./AdicionarAutorizado.vue?vue&type=script&lang=js&"
import style0 from "./AdicionarAutorizado.vue?vue&type=style&index=0&id=2a40e4ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports